import { Button, Link, Spinner, Text } from "@wootingkb/component-library";
import { useDisclosure } from "../../../utils/hooks/useDisclosure";
import { useDiscordUser } from "../../../utils/hooks/useDiscordUser";
import { CTAButtons } from "./CTAButtons";
import useUnlink from "./hooks/useUnlink";
import UnlinkModal from "./modals/UnlinkModal";
import { Notifications } from "./Notifications";
import { Rewards } from "./Rewards";
import { useDiscordAuthUrl } from "./utils";
import { Trans } from "@lingui/react/macro";

function LoginButton() {
  const discordAuthUrl = useDiscordAuthUrl();

  return (
    <Link href={discordAuthUrl} external hideExternalIcon asChild>
      <Button variant="secondary" size="sm">
        <Trans id="Discord_login_button">Log in to Discord</Trans>
      </Button>
    </Link>
  );
}

export function DiscordContent() {
  const { user, isLoading: isUserLoading } = useDiscordUser();
  const { unlink, isLoading } = useUnlink();
  const unlinkModalControls = useDisclosure();

  if (isUserLoading) return <Spinner />;
  if (!user) return <LoginButton />;

  return (
    <>
      <Text size="sm" weight="semibold" className="rb-mask">
        {user.username}
        {/* If the user has a discriminator, add it to the username. otherwise use new name convention */}
        {user.discriminator !== "0" && `#${user.discriminator}`}
      </Text>

      <CTAButtons />

      <UnlinkModal
        isOpen={unlinkModalControls.isOpen}
        onClose={unlinkModalControls.onClose}
        onOpenChange={unlinkModalControls.onOpenChange}
        onConfirm={() => unlink(unlinkModalControls.onClose)}
        isLoading={isLoading}
      />

      <Notifications />
      <Rewards />
    </>
  );
}
